import { Menu, Transition } from '@headlessui/react'
import { User } from 'lucide-react'
import { observer } from 'mobx-react-lite'
import React, { Fragment, useContext, useEffect, useState, useRef } from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import { Context } from '../../..'
import { fetchAllCategories, fetchCarsBrands } from '../../../http/carAndDetailSelectorAPI'
import { check, getProfileNotifications, handleLogout } from '../../../http/userAPI'
import {
	CHAT_ROUTE,
	LOGIN_ROUTE,
	MAIN_ROUTE,
	REGISTRATION_ROUTE,
	USER_PROFILE_ADS,
} from '../../../utils/consts'
import ProfileUser from '../../modals/ProfileUser'
import Logo from '../logo/Logo'
import styles from './Navbar.module.scss'
import NotificationMenu from './NotificationMenu'

const Navbar = observer(() => {
	const [notifications, setNotifications] = useState([])
	const { user, device } = useContext(Context)
	const [openProfileModal, setOpenProfileModal] = useState(false)
	const pathname = useLocation().pathname
	const profileMenu = useRef(null);
	let isLocationChat = '/' + pathname.split('/')[1] === CHAT_ROUTE ? true : false

	useEffect(() => {
		fetchCarsBrands().then(data => device.setTypes(data))
		fetchAllCategories().then(data => device.setCategories(data))
	}, [device])

	useEffect(() => {
		check()
			.then(data => {
				if (data?.status === 200) {
					user.setIsAuth(true)
					user.setId(data.data?.id)
					getProfileNotifications().then(res => {
						setNotifications(res?.data ? res?.data : [])
					})
				}
			})
			.catch(error => {
				user.setIsAuth(false)
			})
		window.scrollTo(0, 0)
	}, [pathname, user])

	return (
		<div className={`${styles.navbar} ${isLocationChat ? 'pb-[30px]' : 'pb-[50px]'} container`}>
			<Logo />

			{user.isAuth ? (
				<div className='flex flex-row'>
					<Menu
						as='div'
						ref={profileMenu}
						className='relative'
						style={{ flexDirection: 'row', display: 'flex' }}
						on>
						{({ open, close }) => (<>
							<NotificationMenu
								notifications={notifications}
								setNotifications={setNotifications}
								closeMenu={close}
							/>
							<div>
								<Menu.Button className='relative flex ml-3'>
									<div className='button button-user'>
										<User />
									</div>
								</Menu.Button>
							</div>
							<Transition
								as={Fragment}
								enter='transition ease-out duration-100'
								enterFrom='transform opacity-0 scale-95'
								enterTo='transform opacity-100 scale-100'
								leave='transition ease-in duration-75'
								leaveFrom='transform opacity-100 scale-100'
								leaveTo='transform opacity-0 scale-95'>
								<Menu.Items
									className='absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none'
									style={{ top: '100%' }}>
									<Menu.Item>
										<div
											type='button'
											onClick={() => {
												setOpenProfileModal(true)
											}}
											className='block px-4 py-2 cursor-pointer text-sm text-gray-900 hover:bg-gray-100 w-full text-left'>
											Мой профиль
										</div>
									</Menu.Item>
									<Menu.Item>
										<NavLink
											to={USER_PROFILE_ADS}
											className='block px-4 py-2 cursor-pointer text-sm text-gray-900 hover:bg-gray-100 w-full text-left'>
											Мои объявления
										</NavLink>
									</Menu.Item>
									<Menu.Item>
										<div
											onClick={() => { window.location = CHAT_ROUTE + `/${user.id}` }}
											className='block px-4 py-2 cursor-pointer text-sm text-gray-900 hover:bg-gray-100 w-full text-left'>
											Мои чаты
										</div>
									</Menu.Item>
									{pathname !== MAIN_ROUTE && (
										<Menu.Item>
											<NavLink
												to={MAIN_ROUTE}
												className='block px-4 py-2 cursor-pointer text-sm text-gray-900 hover:bg-gray-100 w-full text-left'>
												На главную
											</NavLink>
										</Menu.Item>
									)}
									<Menu.Item>
										<div
											type='button'
											onClick={() => {
												user.setIsAuth(false)
												handleLogout()
											}}
											className='block px-4 py-2 cursor-pointer text-sm text-gray-900 hover:bg-gray-100 w-full text-left'>
											Выйти
										</div>
									</Menu.Item>
								</Menu.Items>
							</Transition>
						</>)}
					</Menu>
				</div>
			) : pathname === LOGIN_ROUTE || pathname === REGISTRATION_ROUTE ? (
				//<CustomNavLink isNavbar={true} linkTo={MAIN_ROUTE} text={'На главную'} />
				<NavLink className='button h-12' to={MAIN_ROUTE}>
					На главную
				</NavLink>
			) : (
				<NavLink className='button h-12' to={LOGIN_ROUTE}>
					Войти
				</NavLink>
			)}

			<ProfileUser show={openProfileModal} onHide={setOpenProfileModal} />
		</div>
	)
})

export default Navbar
